var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-header',{staticClass:"sticky"}),_c('router-view'),_c('app-footer',{staticClass:"mt-auto"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }